<template>
  <div class="page_content create-section">

  <div class="page_heading">
    <div class="col-5 module_heading">
      <span class="module_icon icon-channel"></span>
            <span class="module_type_name">Create Channel</span>
    </div>

    <div class="col-7 btn_container">
      <button v-on:click="validateChannel" class="btn btn-primary" aria-label="save">save</button>
      <button v-on:click="cancel" class="btn btn-primary" aria-label="cancel">cancel</button>
      </div>
    </div>
  <div class="content-section">
    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="title">Title <sup>*</sup></div>
        <div class="col-7"><input v-model="channel.channelName" aria-labelledby="title" placeholder="Title" required></div>
      </div>
      <div class="col-6 row">
        <div class="col-4 form-label" id="externalId">External Id<sup>*</sup></div>
        <div class="col-7"><input v-model="channel.externalId" aria-labelledby="externalId" placeholder="External Id (cannot contain spaces)" type="text" required></div>
      </div>
    </div>
    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="title">Entity Id</div>
        <div class="col-7"><input v-model="channel.entityId" aria-labelledby="title" placeholder="Entity ID" required></div>
      </div>
      <div class="col-6 row">
        <div class="col-4 form-label" id="externalId">Entity Type</div>
        <div class="col-7"><input v-model="channel.entityType" aria-labelledby="externalId" placeholder="Entity Type" type="text" required></div>
      </div>
    </div>
    <div class="row content-row">
      <div class="col-6 row">
        <div class="col-4 form-label" id="userRole">Type <sup>*</sup></div>
        <div class="col-7">
          <select v-model="channel.type" aria-labelledby="userRole">
            <option v-for="option in channelTypes" v-bind:value="option">
              {{ option }}
            </option>
          </select>
        </div>
      </div>
    </div>

  </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import '../../../assets/module/sass/channel/channel.scss'

export default {
  name: 'createChannel',
  props: [],
  components: {
  },
  data: () => {
    return {
      channel: {
        channelName: '',
        title: '',
        externalId: '',
        entityId: '',
        entityType: '',
        institutionId: '',
        participants: [],
        type: 'public'
      },
      channelTypes: [
        'public', 'broadcast'
      ]
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCreateChannel'
    ]),

    createChannel () {
      this.channel.institutionId = this.currentInstitutionId
      this.channel.title = this.channel.channelName
      this.loadCreateChannel({channel: this.channel}).then(res => {
        if (res) {
          this.$router.push({ name: 'listChannels' })
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully created channel.'
          })
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please try again.'
          })
        }
      })
    },
    validateChannel () {
      if (this.channel.channelName.length > 0 && this.channel.externalId.length > 0) {
        this.channel.externalId = this.channel.externalId.replace(/\s/g, '_')
        this.createChannel()
      } else {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Title and External Id are required.'
        })
      }
    },
    cancel () {
      this.$router.push({ name: 'listChannels' })
    }

  },

  computed: {
    ...mapState({
    }),
    currentInstitutionId () {
      var userObj = JSON.parse(localStorage.getItem('userobj'))
      return userObj.institutionId
    }
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/channel/components/CreateChannel.vue